// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_rL_","cls2":"ToolsMenu-cls2__EE ToolsMenu-cls1_rL_"};